var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login_d1 flex j-c a-c"},[_c('img',{attrs:{"src":require('~a/imgs/4.png')}}),(_vm.device !== 'mobile')?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }